module.exports = __webpack_public_path__ + "img/icoFacebook.7fe4024d.png";